"use client";

import dynamic from "next/dynamic";

const WebVitalsReporter = dynamic(
  () => import("@/components/analytics/WebVitalsReporter"),
  { ssr: false },
);

export default function WebVitalsReporterLazy() {
  return <WebVitalsReporter />;
}
